const E = 13, _ = 27, O = 37, C = 38, R = 39, o = 40, t = 9, D = 32;
export {
  o as ARROW_DOWN_KEY_CODE,
  O as ARROW_LEFT_KEY_CODE,
  R as ARROW_RIGHT_KEY_CODE,
  C as ARROW_UP_KEY_CODE,
  E as ENTER_KEY_CODE,
  _ as ESC_KEY_CODE,
  D as SPACE_KEY_CODE,
  t as TAB_KEY_CODE
};
//# sourceMappingURL=index.es741.js.map
